import { StorageKeys } from '@constants/common';
import { useLocation, useNavigate } from 'react-router-dom';

const useCustomNavigate = () => {
  const reactNavigate = useNavigate();
  const location = useLocation();

  const customNavigate = (to: any, state?: object) => {
    const path = location.pathname;
    const store = window.localStorage;

    store.setItem(StorageKeys.PREVIOUS_URL, path);

    reactNavigate(to, { state: { ...state, previousUrl: path } });
  };

  return customNavigate;
};

export default useCustomNavigate;
